import '../javascripts/footer';
import { initializeBrandLogoSizing } from '../javascripts/brand-logo-sizing.mjs';
initializeBrandLogoSizing();
import { initializeRecentEventImageRecovery } from '../javascripts/recent-event-image-recovery.mjs';
initializeRecentEventImageRecovery();
